import { MarketWinPlace } from './MarketWinPlace';

export default MarketWinPlace;
